import { Empty, Input, Select, Tooltip ,Pagination } from "antd";
import { convertToObjectKeyString, TranslateString } from "Utils/Common";
import moment from "moment";
import { TenderStatus } from "constants/Constants";
import { BsArrowDownUp } from "react-icons/bs";
import { EditOutlined, UndoOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";
import { useState } from "react";
import { useNavigate } from "react-router";

function CloseLoanTenderingCase(props: any) {
  const intl = useIntl();
  const navigate = useNavigate();
  const [closeSearchData, setCloseSearchData] = useState<any>(
    props.closeSearchData || {},
  );

  //   const onSearch = (event: any) => {
  //     const { target } = event;
  //     const value = target.value;
  //     const { name } = target;

  //     setCloseSearchData({ ...closeSearchData, [name]: value });
  //   };

  //   const onPressEnter = (event: any) => {
  //     props.setCloseSearchData({ ...closeSearchData });
  //   };

  const onSearch = (e: any) => {
    const { name, value } = e.target;
    props.setCloseSearchData((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };
  const onPressEnter = () => {
    props.setCloseSearchData((prev: any) => ({ ...prev }));
  };

  return (
    <>
      <div className="mt-4 cu-table-border">
        <table className="table table-sm table-bordered table-striped text-left">
          <thead>
            <tr>
              <td colSpan={17} className="bg-white fw-bold fs-4">
                {TranslateString("closed_loan_tendering_case")}
              </td>
            </tr>
            <tr className="align-middle cu-text-small">
              <td className="cu-bg-green fw-bold cu-three-width text-center">
                {TranslateString("priority")}
              </td>
              <td className="cu-bg-green fw-bold cu-three-width text-center">
                {TranslateString("tender_id")}
              </td>
              <td className="cu-bg-green fw-bold cu-three-width text-center">
                {TranslateString("customer_id")}
              </td>
              <td className="cu-bg-green fw-bold">
                {TranslateString("customer_name")}
              </td>
              <td className="cu-bg-green fw-bold">
                {TranslateString("loan_name")}
              </td>
              <td className="cu-bg-green fw-bold cu-three-width text-center">
                {TranslateString("loan_invoicing_model")}
              </td>
              <td className="cu-bg-green fw-bold cu-seven-width text-right">
                {TranslateString("current_capital")}
              </td>
              <td className="cu-bg-green fw-bold cu-five-width text-right">
                {TranslateString("margin")}
              </td>
              <td className="cu-bg-green fw-bold cu-three-width">
                {TranslateString("loaner_grouped")}
              </td>
              <td className="cu-bg-green fw-bold cu-three-width">
                {TranslateString("city")}
              </td>
              <td className="cu-bg-green fw-bold">
                {TranslateString("sännöitsijä")}
              </td>
              {/* <td className="cu-bg-green fw-bold">
                {TranslateString("housing_manager_comment")}
              </td>
              <td className="cu-bg-green fw-bold">
                {TranslateString("Kirjanpitäjä")}
              </td> */}
              <td className="cu-bg-green fw-bold">
                {TranslateString("Moderaattori")}
              </td>
              <td className="cu-bg-green fw-bold">
                {TranslateString("status")}
              </td>
              <td className="cu-bg-green fw-bold">
                {TranslateString("deadline")}
              </td>
              <td className="cu-bg-green fw-bold cu-ten-width">
                {TranslateString("tendering_notes")}
              </td>
              <td className="cu-bg-green fw-bold cu-three-width">
                {TranslateString("number_of_tenders_received")}
              </td>
              <td className="cu-bg-green fw-bold">
                {TranslateString("actions")}
              </td>
            </tr>
            <tr className="align-middle cu-text-small">
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setCloseSearchData({
                          ...props.closeSearchData,
                          sort_by: "loan_data_priority",
                        });
                        props.setCloseSort(!props.closeSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_data_priority"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.closeSearchData.loan_tender_id || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setCloseSearchData({
                          ...props.closeSearchData,
                          sort_by: "loan_tender_id",
                        });
                        props.setCloseSort(!props.closeSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_tender_id"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.closeSearchData.loan_data_customerid || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setCloseSearchData({
                          ...props.closeSearchData,
                          sort_by: "loan_data_customerid",
                        });
                        props.setCloseSort(!props.closeSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_data_customerid"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.closeSearchData.loan_data_customername || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setCloseSearchData({
                          ...props.closeSearchData,
                          sort_by: "loan_data_customername",
                        });
                        props.setCloseSort(!props.closeSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_data_customername"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.closeSearchData.loan_data_name || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setCloseSearchData({
                          ...props.closeSearchData,
                          sort_by: "loan_data_name",
                        });
                        props.setCloseSort(!props.closeSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_data_name"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.closeSearchData.loan_invoicing_model || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setCloseSearchData({
                          ...props.closeSearchData,
                          sort_by: "loan_invoicing_model",
                        });
                        props.setCloseSort(!props.closeSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_invoicing_model"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.closeSearchData.loan_data_agreement || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setCloseSearchData({
                          ...props.closeSearchData,
                          sort_by: "loan_data_agreement",
                        });
                        props.setCloseSort(!props.closeSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_data_agreement"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.closeSearchData.loan_data_margin || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setCloseSearchData({
                          ...props.closeSearchData,
                          sort_by: "loan_data_margin",
                        });
                        props.setCloseSort(!props.closeSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_data_margin"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.closeSearchData.loan_data_bank_group || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setCloseSearchData({
                          ...props.closeSearchData,
                          sort_by: "loan_data_bank_group",
                        });
                        props.setCloseSort(!props.closeSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_data_bank_group"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.closeSearchData.cust_data_city || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setCloseSearchData({
                          ...props.closeSearchData,
                          sort_by: "cust_data_city",
                        });
                        props.setCloseSort(!props.closeSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="cust_data_city"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.closeSearchData.cust_data_manager_name || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setCloseSearchData({
                          ...props.closeSearchData,
                          sort_by: "cust_data_manager_name",
                        });
                        props.setCloseSort(!props.closeSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="cust_data_manager_name"
                />
              </td>
              {/* <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.closeSearchData.hm_comment || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setCloseSearchData({
                          ...props.closeSearchData,
                          sort_by: "hm_comment",
                        });
                        props.setCloseSort(!props.closeSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="hm_comment"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.closeSearchData.accountant_name || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setCloseSearchData({
                          ...props.closeSearchData,
                          sort_by: "accountant_name",
                        });
                        props.setCloseSort(!props.closeSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="accountant_name"
                />
              </td> */}
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.closeSearchData.created_by || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setCloseSearchData({
                          ...props.closeSearchData,
                          sort_by: "created_by",
                        });
                        props.setCloseSort(!props.closeSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="created_by"
                />
              </td>
              <td className="cu-bg-green" width={100}>
                <Select
                  placeholder={TranslateString("select")}
                  value={props.closeSearchData.status || ""}
                  showSearch
                  className="w-100"
                  onChange={(value: any) => {
                    setCloseSearchData({ ...closeSearchData, status: value });
                    props.setCloseSearchData({
                      ...props.closeSearchData,
                      status: value,
                    });
                  }}
                  options={[
                    ...TenderStatus.map(({ value, label }) => {
                      return {
                        value: value,
                        label: intl.formatMessage({
                          id: convertToObjectKeyString(value),
                        }),
                      };
                    }),
                  ]}
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.closeSearchData.loan_tender_deadline || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setCloseSearchData({
                          ...props.closeSearchData,
                          sort_by: "loan_tender_deadline",
                        });
                        props.setCloseSort(!props.closeSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_tender_deadline"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.closeSearchData.loan_tender_notes || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setCloseSearchData({
                          ...props.closeSearchData,
                          sort_by: "loan_tender_notes",
                        });
                        props.setCloseSort(!props.closeSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_tender_notes"
                />
              </td>
              <td className="cu-bg-green"></td>
              <td className="cu-bg-green"></td>
            </tr>
          </thead>
          <tbody className="cu-text-small">
            {props?.tenderData?.getCloseTender?.length > 0 ? (
              props?.tenderData?.getCloseTender?.map((val: any) => {
                return (
                  <tr>
                    <td className="text-center fw-bold">
                      {val?.LOAN_DATA?.loan_data_priority || "-"}
                    </td>
                    <td className="text-center fw-bold">
                      {val?.loan_tender_id || "-"}
                    </td>
                    <td
                      className="text-center fw-bold cu-link"
                      role="button"
                      onClick={() => {
                        navigate(
                          "/single-loan/" +
                            val?.LOAN_DATA?.loan_data_customerid +
                            "/" +
                            val?.loan_tender_id,
                          {
                            state: { tender_case: "close" },
                          },
                        );
                      }}
                    >
                      {val?.LOAN_DATA?.loan_data_customerid || "-"}
                    </td>
                    <td>{val?.LOAN_DATA?.loan_data_customername || "-"}</td>
                    <td>
                      {val?.LOAN_DATA?.loan_data_name?.replace(
                        "Uusi laina:",
                        TranslateString("new_loan"),
                      ) || "-"}
                    </td>
                    <td className="text-center">
                      {val?.LOAN_DATA?.loan_invoicing_model || "-"}
                    </td>
                    <td className="text-right fw-bold text-nowrap">
                      {val?.LOAN_DATA?.loan_data_agreement || "-"}
                    </td>
                    <td className="text-right fw-bold text-nowrap">
                      {val?.LOAN_DATA?.loan_data_margin || "-"}
                    </td>
                    <td>{val?.LOAN_DATA?.loan_data_bank_group || "-"}</td>
                    <td>{val?.LOAN_DATA?.CUST_DATA?.cust_data_city || "-"}</td>
                    <td>
                      {val?.LOAN_DATA?.CUST_DATA?.cust_data_manager_name || "-"}
                    </td>
                    {/* <td>{val?.hm_comment || "-"}</td>
                    <td>{val?.LOAN_DATA?.CUST_DATA?.accountant_name || "-"}</td> */}
                    <td>{val?.created_by || "-"}</td>
                    <td>
                      {val?.loan_tender_status
                        ? intl.formatMessage({
                            id: convertToObjectKeyString(
                              val?.loan_tender_status,
                            ),
                          })
                        : "-"}
                    </td>
                    <td>
                      {val?.loan_tender_deadline
                        ? moment(val?.loan_tender_deadline).format("DD.MM.YYYY")
                        : "-"}
                    </td>
                    <td>{val?.loan_tender_notes || "-"}</td>
                    <td className="text-center fw-bold">
                      {val?.no_of_tenders_received || "-"}
                    </td>
                    <td className="text-center" role="button">
                      <div className="d-flex">
                        <div>
                          <Tooltip title={TranslateString("edit")}>
                            <EditOutlined
                              className="fs-5"
                              onClick={() => {
                                props.setDeadlineRequired(false);
                                props.setNotesRequired(false);
                                props.handleEdit(val);
                              }}
                            />
                          </Tooltip>
                        </div>
                        <div>&nbsp;</div>
                        <div>
                          <Tooltip title={TranslateString("re_tender")}>
                            <UndoOutlined
                              onClick={() => props.onSelectReTender(val)}
                              className="m-0 cu-font-bold cu-font-export"
                            />
                          </Tooltip>
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={17}>
                  <Empty description={TranslateString("Empty")} />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/* <div className="d-flex justify-content-end mt-3">
        <div>
          {`${(props.closePageData?.page || 0) * (props.closePageData?.size || 50) + 1}
      -
      ${Math.min(
        ((props.closePageData?.page || 0) + 1) *
          (props.closePageData?.size || 50),
        props.closeTotalRecords || 0,
      )}
      of ${props.closeTotalRecords || 0} items`}
        </div>
        <Pagination
          current={(props.closePageData?.page || 0) + 1}
          pageSize={props.closePageData?.size || 50}
          total={props.closeTotalRecords || 0}
          showSizeChanger
          onChange={(page, pageSize) => {
            props.setClosePageData({
              page: page - 1,
              size: pageSize,
            });
          }}
        />
      </div> */}
      {/* <div className="d-flex justify-content-end mt-3">
         <div>
    {`${((props.closePageData?.page || 0) * (props.closePageData?.size || 50)) + 1}
      -
      ${Math.min(
        ((props.closePageData?.page || 0) + 1) *
          (props.closePageData?.size || 50),
        props.closeTotalRecords || 0
      )}
      of ${props.closeTotalRecords || 0} items`}
  </div>
  <Pagination
  current={(props.closePageData?.page || 0) + 1}
  pageSize={props.closePageData?.size || 50}
  total={props.closeTotalRecords || 0}
  showSizeChanger
  onChange={(page, pageSize) => {
    props.setClosePageData({
      page: page - 1,
      size: pageSize,
    });
  }}
/>
</div> */}
<div className="d-flex justify-content-end align-items-center gap-3 mt-3">
  <div>
    {props.closePageData?.size === -1
      ? `1 - ${props.closeTotalRecords} of ${props.closeTotalRecords} items`
      : `${((props.closePageData?.page || 0) * (props.closePageData?.size || 50)) + 1}
        -
        ${Math.min(
          ((props.closePageData?.page || 0) + 1) *
            (props.closePageData?.size || 50),
          props.closeTotalRecords || 0
        )}
        of ${props.closeTotalRecords || 0} items`}
  </div>

  
  <Pagination
    current={
      props.closePageData?.size === -1
        ? 1
        : (props.closePageData?.page || 0) + 1
    }
    pageSize={
      props.closePageData?.size === -1
        ? props.closeTotalRecords
        : props.closePageData?.size
    }
    total={props.closeTotalRecords || 0}
    showSizeChanger={false}
    onChange={(page) => {
      props.setClosePageData({
        page: page - 1,
        size: props.closePageData?.size,
      });
    }}
  />
  <Select
    style={{ width: 100 }}
    value={props.closePageData?.size}
    onChange={(value) => {
      props.setClosePageData({
        page: 0,
        size: value,
      });
    }}
    options={[
      { label: "10", value: 10 },
      { label: "20", value: 20 },
      { label: "50", value: 50 },
      { label: "100", value: 100 },
      { label: "All", value: -1 },
    ]}
  />

</div>
    </>
  );
}
export default CloseLoanTenderingCase;
